module.exports = __webpack_public_path__ + "static/Logo_Alt@2x-32173842eabc961efa6e56c49edd5108.svg";